// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__2R08r","contentBox":"style_contentBox__39nn2"};